import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var Diploma = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.73 9.592c2-2 2-5.3 0-7.301-2.001-2-5.302-2-7.302 0l-.8.9c-1.1 1.2-1.1 3 0 4.2 1.2 1.201 3 1.201 4.2 0 .9-.9-.5-2.3-1.4-1.4-.4.4-1 .4-1.4 0-.4-.4-.4-1 0-1.4l.8-.9c3.1-2.9 7.402 1.5 4.5 4.5l-1.4 1.401c-5.5 5.101-13.002-2.5-7.901-7.902.9-.9-.5-2.3-1.4-1.4L12.622 17.294 3.02 26.996C.02 29.896.02 34.698 3.02 37.7c3 3 7.801 3 10.702 0l3.1-3.101 5.602 8.902c.2.3.5.5.9.5s.7-.2.8-.5l2.4-4.801 5.302-.1c.4 0 .7-.2.9-.5.2-.3.2-.7 0-1l-2.8-4.502 4.5 2.801c.3.2.7.2 1 0 .3-.2.5-.5.5-.9l.101-5.301 4.801-2.4c.3-.2.5-.501.5-.801 0-.4-.2-.7-.5-.9l-8.902-5.602c.8-.9 9.202-9.202 9.802-9.902ZM16.223 32.397l-3.901 3.901a5.554 5.554 0 0 1-7.902 0c-2.2-2.2-2.2-5.801 0-7.902l6.101-6.1 6.502-6.502c-.1 2.1.6 4.2 2.2 5.7 1.6 1.601 3.701 2.302 5.701 2.201l-8.701 8.702Zm13.803 4.301-4.201.1c-.4 0-.7.2-.9.5L23.125 41l-4.902-7.801 4.901-4.802 2.9 1.8 4.002 6.502Zm8.201-10.802-3.7 1.9c-.3.2-.5.5-.5.9l-.1 4.201c-1.9-1.2-7.602-4.8-9.403-5.9l5.902-5.902 7.801 4.8Zm-8.602-6.902s-1.1 1-1.1 1.1c-5.401 5.102-13.003-2.5-7.901-7.901l6.901-6.902c-.4 4.201 3.7 8.402 8.002 7.902l-5.901 5.801Z"
  }));
});
Diploma.displayName = 'Diploma';
Diploma.defaultProps = {
  'aria-label': 'Diploma'
};
export default Diploma;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Subject/Diploma.js
// module id = 3629
// module chunks = 11